import { Parcel, Item, ShipmentType } from '../types/common';
import Currency from '../utils/currency';

export const ENVELOPE_WEIGHT = 0.06;

export type DocumentPresetId = 'envelope'; // 'pak'

export type ParcelPresetId = 'small' | 'medium' | 'large';

export type PresetId = DocumentPresetId | ParcelPresetId;

const documentPreset: Record<DocumentPresetId, Parcel> = {
  envelope: { length: 33, width: 23, height: 1, weight: 0.5 },
};

const parcelPreset: Record<ParcelPresetId, Parcel> = {
  small: { length: 30, width: 22, height: 13, weight: 2 },
  medium: { length: 42, width: 25, height: 28, weight: 6 },
  large: { length: 48, width: 35, height: 35, weight: 12 },
};

export const presetSizes: Record<ShipmentType, Record<string, Parcel>> = {
  [ShipmentType.DOCUMENT]: documentPreset,
  [ShipmentType.PARCEL]: parcelPreset,
};
